import {uploadControllerActionTypes} from '../actions/uploadController-action-types';
import {addToArrayIfNewObject, removeObjectInArray, replaceObjectInArray} from '../../common/reducer-helpers';
import {albumActionTypes} from "../../album-view/actions/album-action-types";


const uploadInitialState = {
    filesToUpload: [],
    filesInProcess: [],
    filesComplete: [],
    albumsImUploadingTo: [],
    uploadInProgress: false,
    isPaused: false,
    uploadComplete: false,
    uploadStarted: 0,
    uploadInProcess: false,
    uploadAlbumId: 0,
    uploadAlbumIdDrop: -1,
    uploadAlbumName: '',
    albumSelectList: [],
};

export const uploadController = (state = uploadInitialState, action) => {
    const file = action.file;
    switch (action.type) {

        case albumActionTypes.ALBUM_UPDATED: {
            let albums = state.albumSelectList.slice();
            let found = false;
            for (var i = 0; i < albums.length; i++) {
                if (albums[i].key == action.albumItem.id) {
                    found = true;
                    albums[i].label = action.albumItem.title;
                }
            }
            if(!found){
                albums.push({key: action.albumItem.id,label: action.albumItem.title});
            }
            albums.sort((left, right) => left.label.localeCompare(right.label))

            return {...state, albumSelectList: albums, selectedAlbumId: action.albumItem.id}
        }
        case uploadControllerActionTypes.UPLOAD_CONTROLLER_ADD_FILE:


            return {
                ...state,
                filesToUpload: addToArrayIfNewObject(state.filesToUpload, action),

                filesInProcess: addToArrayIfNewObject(state.filesInProcess, action),
                albumsImUploadingTo: state.albumsImUploadingTo.indexOf(file.ccId) === -1 ? [...state.albumsImUploadingTo, file.ccId] : [...state.albumsImUploadingTo],
                uploadAlbumId: file.ccId,
                uploadComplete: false,
                uploadStarted: state.uploadStarted ? state.uploadStarted : Date.now(),

            };

        case uploadControllerActionTypes.UPLOAD_CONTROLLER_ADD_FILES:
            return {
                ...state,
                filesToUpload: [...state.filesToUpload, ...action.files],
                filesInProcess: [...state.filesInProcess, ...action.files],
                uploadComplete: false,
                uploadStarted: state.uploadStarted ? state.uploadStarted : Date.now(),
                uploadAlbumId: action.uploadAlbumId

            };
        case uploadControllerActionTypes.UPLOAD_CONTROLLER_FILE_PROGRESS:
            return {
                ...state,
                filesToUpload: replaceObjectInArray(state.filesToUpload, action),
                uploadInProcess: true
                // filesInProcess: replaceObjectInArray(state.filesInProcess, action)

            };
        case uploadControllerActionTypes.UPLOAD_CONTROLLER_FILE_COMPLETE:
            return {
                ...state,
                filesInProcess: removeObjectInArray(state.filesInProcess, action),
                filesComplete: [...state.filesComplete, action.file],
                uploadInProcess: false
                //  filesToUpload: replaceObjectInArray(state.filesInProcess, action)

            };
        case uploadControllerActionTypes.UPLOAD_CONTROLLER_CLEAR_UPLOADS:
            return {
                ...state,
                filesInProcess: [],
                isPaused: false

            };


        case uploadControllerActionTypes.UPLOAD_CONTROLLER_PAUSE:
            return {
                ...state,
                isPaused: !state.isPaused
            };
        case uploadControllerActionTypes.UPLOAD_CONTROLLER_ALL_FILES_UPLOADED:
            return {
                ...state,
                uploadComplete: true,
                uploadInProcess: false,
                uploadStarted: 0
            };
        case uploadControllerActionTypes.UPLOAD_CONTROLLER_ALL_FILES_UPLOADED_CLEAR:
            return {
                ...state,
                uploadComplete: false
            };
        case uploadControllerActionTypes.UPLOAD_CONTROLLER_CLEAR_UPLOADS_LIST:
            return {
                ...state,
                uploadComplete: false,
                filesInProcess: [],
                filesToUpload: [],
                filesComplete: [],
                uploadStarted: 0

            };
        case uploadControllerActionTypes.UPLOAD_CONTROLLER_SET_CURRENT_ALBUM:
            return {
                ...state,
                uploadAlbumIdDrop: action.albumId,
                uploadAlbumName: action.albumName


            };
        case uploadControllerActionTypes.UPLOAD_CONTROLLER_ALBUM_SELECT_LIST: {
            const albumSelectList = action.albums.map(album => {
                return ({key: album.id, label: album.title});
            });
            const newIdSet = new Set(albumSelectList.map(it => it.key));
            const combinedList = state.albumSelectList
                .filter(it => !newIdSet.has(it.key))
                .concat(albumSelectList)
            combinedList.sort((left, right) => {
                if (!left.label) {
                    return -1;
                } else if (!right.label) {
                    return 1;
                } else {
                    return left.label.localeCompare(right.label)
                }
            })
            return {
                ...state,
                albumSelectList: combinedList
            }
        }
        default:
            return state;
    }
};




// WEBPACK FOOTER //
// ./src/uploadController/reducers/uploadController-reducers.js